import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useStyles } from "../../assets/jss/ContentDetails";
import CustomTabs from "../CustomComponents/CustomTabs/CustomTabs";
import CustomTab from "../CustomComponents/CustomTab/CustomTab";
import CustomBox from "../CustomComponents/CustomBox/CustomBox";
import CustomPaper from "../CustomComponents/CustomPaper/CustomPaper";
import CustomCard from "../CustomComponents/CustomCard/CustomCard";
import CustomTypography from "../CustomComponents/CustomTypography/CustomTypography";
import CustomCardContent from "../CustomComponents/CustomCardContent/CustomCardContent";
import QuizComponent from "../ContentTypeComponents/QuizComponent/QuizComponent";
import TextComponent from "../ContentTypeComponents/TextComponent/TextComponent";
import VideoComponent from "../ContentTypeComponents/VideoComponent/VideoComponent";
import { ContentType } from "../../config/app-globals.enum";
import VideoComponentPreview from "../ContentTypeComponents/VideoComponentPreview/VideoComponentPreview";
import QuizComponentPreview from "../ContentTypeComponents/QuizComponentPreview/QuizComponentPreview";
import TextComponentPreview from "../ContentTypeComponents/TextComponentPreview/TextComponentPreview";
import ErrorAlert from "../ErrorAlert/ErrorAlert";
import { getQuote } from "../../services/QuotesServices";
import quoteIcon from "../../assets/images/quoteIcon.svg";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export default function ContentDetailsTab(props) {
  const params = useParams();
  const { t } = useTranslation();
  const classes = useStyles();
  const [showTabIndex, setShowTabIndex] = useState(props.value);
  const [showTab, setShowTab] = useState(props.showTab);
  const [isDriver, setIsDriver] = useState(props.isDriver);
  const [content, setContent] = useState(null);
  const [mobileTokenParam] = useState(props.mobileTokenParam);
  const [quote, setQuote] = useState(null);

  useEffect(() => {
    setShowTabIndex(props.showTabIndex);
  }, [props.showTabIndex]);

  useEffect(() => {
    setShowTab(props.showTab);
  }, [props.showTab]);

  useEffect(() => {
    setIsDriver(props.isDriver);
  }, [props.isDriver]);

  useEffect(() => {
    if (props.content) {
      setContent(props.content);
    }
  }, [props.content]);

  React.useEffect(() => {
    if (isDriver) {
      getQuoteOfTheDay();
    }
  }, [isDriver]);

  const getQuoteOfTheDay = async () => {
    setAlertMessage("");
    setIsAlertOpen(false);
    const data = await getQuote(mobileTokenParam, params);
    if (
      data &&
      (data.status.code === 0 ||
        data.status.code === 200 ||
        data.status.code === 201) &&
      data.content
    ) {
      setQuote(data.content);
    } else {
      changeApiStatusCodeFunc(data.status);
    }
  };

  const [statusValue, setStatusValue] = React.useState();
  const [alertMessage, setAlertMessage] = React.useState("");
  const [isAlertOpen, setIsAlertOpen] = React.useState(false);

  const changeApiStatusCodeFunc = (status) => {
    if (status.code && status.code !== 0 && status.code !== 200) {
      setStatusValue(status.code);
      setAlertMessage(
        status.message
          ? status.message
          : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
      );
      setIsAlertOpen(true);
    }
  };
  //====

  const handleTabs = (event, newTabIndex) => {
    const _showTab =
      newTabIndex === 0
        ? t("EMAIL_MESSAGE")
        : newTabIndex === 1
          ? t("CONTENT")
          : null;
    if (showTab === _showTab) return;
    setShowTab(_showTab);
    setShowTabIndex(newTabIndex);
  };
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  function TabPanel(props) {
    const { children, value, index, ...other} = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <CustomBox m={3}>{children}</CustomBox>}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
    className:PropTypes.any,
  };

  return (
    <>
      {isDriver === false && (
        <CustomTabs
          value={showTabIndex}
          onChange={handleTabs}
          aria-label="simple tabs example"
          indicatorColor="primary"
          className={classes.tabs}
        >
          <CustomTab label={t("EMAIL_MESSAGE")} {...a11yProps(0)} />
          <CustomTab label={t("CONTENT")} {...a11yProps(1)} />
        </CustomTabs>
      )}
      {isDriver === false && (
        <>
          <TabPanel
            key="tab-panel-email"
            value={showTabIndex}
            index={0}
            className={classes.tabPanel}
          >
            <CustomPaper elevation={0} m={0}>
              <CustomCard elevation={0} className={classes.cardContentWrapper}>
                <CustomCardContent className={classes.cardContent}>
                  <CustomBox className={classes.cardContentBody}>
                    {content && content.emailSubjectLine && (
                      <CustomTypography
                        component="h3"
                        variant="h3"
                        className={classes.headerTitle}
                      >
                        {content.emailSubjectLine}
                      </CustomTypography>
                    )}
                    {content && content.emailMessageBody && (
                      <CustomBox
                        className={classes.contentDesc}
                        dangerouslySetInnerHTML={{
                          __html: content.emailMessageBody,
                        }}
                      />
                    )}
                  </CustomBox>
                </CustomCardContent>
              </CustomCard>
            </CustomPaper>
          </TabPanel>
          <TabPanel
            key="tab-panel-content"
            value={showTabIndex}
            index={1}
            className={classes.tabPanel}
          >
            {content &&
              (content.contentTypeId === ContentType.ARTICLE ||
                content.contentTypeId === ContentType.EMAIL_MESSAGE) ? (
              <TextComponentPreview
                content={content}
                mobileTokenParam={mobileTokenParam}
              />
            ) : null}
            {content && content.contentTypeId === ContentType.QUIZ ? (
              <QuizComponentPreview
                content={content}
                mobileTokenParam={mobileTokenParam}
              />
            ) : null}
            {content &&
              (content.contentTypeId === ContentType.DRIVING_VIDEO ||
                content.contentTypeId === ContentType.ANIMATION) ? (
              <VideoComponentPreview
                content={content}
                mobileTokenParam={mobileTokenParam}
              />
            ) : null}
          </TabPanel>
        </>
      )}
      {isDriver === true && content && (
        <>
          <CustomBox
            display="flex"
            flexWrap="wrap"
            alignItems="center"
            justifyContent="space-between"
            mb={4}
            mt={5}
          >
            {quote && (
              <CustomBox className={classes.quoteWrapper}>
                <CustomTypography
                  component="h1"
                  variant="h5"
                  className={classes.quote}
                >
                  <span className={classes.quoteIcon}>
                    <img src={quoteIcon} />
                  </span>
                  {quote.message}
                </CustomTypography>
                <CustomTypography
                  component="h5"
                  variant="h5"
                  className={classes.quoteSubText}
                >
                  Praiso - {quote.title}
                </CustomTypography>
              </CustomBox>
            )}
          </CustomBox>
          <CustomBox className={classes.tabPanel}>
            {content.contentTypeId === ContentType.ARTICLE ||
              content.contentTypeId === ContentType.EMAIL_MESSAGE ? (
              <TextComponent
                content={content}
                mobileTokenParam={mobileTokenParam}
              />
            ) : null}
            {content.contentTypeId === ContentType.QUIZ ? (
              <QuizComponent
                content={content}
                mobileTokenParam={mobileTokenParam}
              />
            ) : null}
            {content.contentTypeId === ContentType.DRIVING_VIDEO ||
              content.contentTypeId === ContentType.ANIMATION ? (
              <VideoComponent
                content={content}
                mobileTokenParam={mobileTokenParam}
              />
            ) : null}
          </CustomBox>
          <ErrorAlert
            code={statusValue}
            message={alertMessage}
            isOpen={isAlertOpen}
            isClose={(isClose) => setIsAlertOpen(!isClose)}
          />
        </>
      )}
    </>
  );
}
